import { Component, OnDestroy, Input } from '@angular/core';
import { ReplaySubject } from 'rxjs';

import { Loggable } from 'app/utils/logging/loggable';
import SocialTheme from 'entity/SocialTheme';

@Component({
  selector: 'room-background-card',
  templateUrl: './room-background-card.component.html',
  styleUrls: ['./room-background-card.component.scss'],
  standalone: false,
})
export class RoomBackgroundCardComponent extends Loggable implements OnDestroy {
  private destroyed$ = new ReplaySubject<boolean>(1);
  @Input() public theme?: SocialTheme;
  @Input() public themeLabel?: string;
  @Input() public isScootaverseCard?: boolean = false;

  public constructor() {
    super();
    this.setDisplayName('BackgroundCardComponent');
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public isBackgroundContiguous(theme?: SocialTheme): boolean {
    return !!theme?.minimapImageURI;
  }

  public roomSetBackgroundImage(theme?: SocialTheme): string | undefined {
    if (theme) {
      return theme.minimapImageURI;
    } else {
      return undefined;
    }
  }

  public backgroundHasImages(theme?: SocialTheme): boolean {
    return !!theme?.imageFarURI || !!theme?.imageMidURI || !!theme?.imageNearURI;
  }

  public roomImageFarURI(theme?: SocialTheme): string {
    return theme?.imageFarURI ? theme?.imageFarURI : '';
  }

  public roomImageMidURI(theme?: SocialTheme): string {
    return theme?.imageMidURI ? theme?.imageMidURI : '';
  }

  public roomImageNearURI(theme?: SocialTheme): string {
    return theme?.imageNearURI ? theme?.imageNearURI : '';
  }
}
